/**
 * URL utility functions for normalizing and validating URLs
 */

/**
 * Normalizes a URL by adding https:// protocol if missing
 * @param {string} url - The URL to normalize
 * @returns {string} - The normalized URL with protocol
 */
export const normalizeURL = (url) => {
  if (!url) return url;
  
  // Trim whitespace
  let normalizedUrl = url.trim();
  
  // If URL already has a protocol, return as is
  if (normalizedUrl.match(/^https?:\/\//)) {
    return normalizedUrl;
  }
  
  // If URL starts with www., add https://
  if (normalizedUrl.match(/^www\./)) {
    return `https://${normalizedUrl}`;
  }
  
  // If URL doesn't start with protocol or www., add https://
  if (!normalizedUrl.match(/^https?:\/\//) && !normalizedUrl.match(/^www\./)) {
    return `https://${normalizedUrl}`;
  }
  
  return normalizedUrl;
};

/**
 * Validates if a URL is valid after normalization
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if URL is valid
 */
export const isValidURL = (url) => {
  try {
    const normalizedUrl = normalizeURL(url);
    new URL(normalizedUrl);
    return true;
  } catch {
    return false;
  }
};

/**
 * Gets a user-friendly display URL (removes protocol for display)
 * @param {string} url - The full URL
 * @returns {string} - The display URL without protocol
 */
export const getDisplayURL = (url) => {
  if (!url) return url;
  
  // Remove protocol and trailing slash for display
  return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
};
